import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_messaging-in_product_message_banner-hover';
/**
 * Trigger when retailer hovers on the in product messaging banner
 */
export function trackProductMessagingInProductMessageBannerHover(campaign_name) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { campaign_name },
    });
}
